import * as types from '../actions/actionTypes'
const extend = require('lodash/extend');


const eventsReducer = (state = {
    allEvents: [],
    allEventsAnalytics: [],
}, action) => {

    switch(action.type) {
        case types.GET_EVENTS_INFO_FOR_USER_SUCCESS: 
            var merged = extend({}, state.allEvents, action.payload);
            state = {
                ...state,
                allEvents: merged,
            };
        break;
        case types.GET_EVENT_ANALYTICS_SUCCESS:
            
            state = {
                ...state,
                allEventsAnalytics: action.payload ? action.payload: [],
            };
        break;
        default:
        break;    
    }

    return state;
};


export default eventsReducer;


// WEBPACK FOOTER //
// ./src/reducers/eventsReducer.js